import React from 'react';
import { PlansSummaryTable } from './PlansSummaryTable';
import { useOnboardingStore } from '@features/onboarding/store/onboarding';
import { congratulationsContent } from 'src/features/onboarding/components/7-finish/content/content';
import { usePlan } from '@features/onboarding/hooks/usePlan';

export const HereYourPlans = ({ children, isChangePlan }: { children?: React.ReactNode, isChangePlan?: boolean }) => {
  const { data } = useOnboardingStore();
  const { plans } = usePlan();

  const primaryApplicant = data.applicants?.[0];
  const primaryApplicantName = primaryApplicant ? primaryApplicant.firstName : '';

  const planTitle = plans.length === 1 ? 'Here is your plan' : 'Here are your plans';

  return (
    <section className="md:flex md:rounded-xl md:flex-col md:py-8 md:px-10">
      <h1 className="text-4xl font-extrabold mb-2">
        {planTitle}, {primaryApplicantName}!
      </h1>
      <p className="text-[15px] mb-2 leading-5 max-w-186 !font-secondary tracking-tight">
        {congratulationsContent.paragraph1}
      </p>
      {/* <p className="text-base !font-secondary tracking-tight">
        {congratulationsContent.paragraph2}
      </p> */}
      <PlansSummaryTable contributionAmount={0} isChangePlan={isChangePlan} />
      {children}
    </section>
  );
};
